import { Button, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../../context";
import { RowSecretType } from "../../TableBody";

export default function SecretKey({ isClient, secretKey, id }: RowSecretType) {
	const { actions } = useContext(Context);
	const { translate } = useLocales();

	if (isClient) return <Typography variant='subtitle2'>{secretKey}</Typography>;
	else
		return (
			<Button
				variant='outlined'
				size='small'
				color='error'
				onClick={() => actions.showCheckPassRevokeDialog(id)}
			>
				{translate("app_secrets.revoke")}
			</Button>
		);
}
